module.exports = __webpack_public_path__ + "media/images/technical_leader-1-fc3a3588.jpg";